import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "./../context/AppContext";
import wellbeinglogo from "../assets/images/wellbeinglogo.svg";
import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "jquery/dist/jquery.min.js";
//Datatable Modules
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import $ from "jquery";
import { useNavigate } from "react-router-dom";

import ic_dashboard from "../assets/images/ic_dashboard.svg";
import ic_admin from "../assets/images/ic_admin.svg";

import ic_about from "../assets/images/ic_about.svg";
import ic_category from "../assets/images/ic_category.svg";
import ic_machine from "../assets/images/ic_machine.svg";
import ic_order from "../assets/images/ic_order.svg";
import ic_privacy from "../assets/images/ic_privacy.svg";
import ic_product from "../assets/images/ic_product.svg";
import ic_qr from "../assets/images/ic_qr.svg";
import ic_query from "../assets/images/ic_query.svg";
import ic_term from "../assets/images/ic_term.svg";
import ic_transaction from "../assets/images/ic_transaction.svg";
import ic_user from "../assets/images/ic_user.svg";
import ApiConfig from "../api/ApiConfig";
import { simpleGetCall } from "../api/ApiServices";
const Dashboard = () => {
  const { sidebar, count } = useContext(AppContext);
  const navigate = useNavigate();
  const [dashCount, setDashCount] = useState({});

  useEffect(() => {
    getDashList();
  }, [])

  const getDashList = () => {
    simpleGetCall(ApiConfig.GET_ALL_COUNTS_DASH)
      .then((res) => {
        setDashCount(res);
        console.log("DASHBOARD DATA LENGTH", res)
      })
      .catch((err) => {
        console.log("Dash Error", err);
      })
  }

  useEffect(() => {
    $(document).ready(function () {
      $("#table_id").DataTable();
    });
  }, []);

  return (
    <main
      id="cx-main"
      className={sidebar ? "dashboard-main" : "cx-active dashboard-main"}
    >
      <div className="dashboard-wrapper">
        <div className="heading-common">
          <label htmlFor="">DASHBOARD</label>
        </div>
        <div className="row mt-3">
          <div className="col-md-4">
            <Link className="mainCards" to="/Admin">
              <div className="ineerCard">
                <div className="innerIcon">
                  <img src={ic_admin} alt="" />
                </div>
                <div className="innerText">
                  <div className="col headingText">ADMINS</div>
                  <div className="col count">{dashCount?.adminCount}</div>
                </div>
              </div>
            </Link>
          </div>
          <div className="col-md-4">
            <Link className="mainCards" to="/Users">
              <div className="ineerCard">
                <div className="innerIcon">
                  <img src={ic_user} alt="" />
                </div>
                <div className="innerText">
                  <div className="col headingText">USERS</div>
                  <div className="col count">{dashCount?.userCount}</div>
                </div>
              </div>
            </Link>
          </div>
          <div className="col-md-4">
            <Link className="mainCards" to="/VendingMachine">
              <div className="ineerCard">
                <div className="innerIcon">
                  <img src={ic_machine} alt="" />
                </div>
                <div className="innerText">
                  <div className="col headingText">VENDING MACHINE</div>
                  <div className="col count">{dashCount?.vendingMachineCount}</div>
                </div>
              </div>
            </Link>
          </div>
        </div>
        <div className="row ">
          <div className="col-md-4">
            <Link className="mainCards" to="/Categories">
              <div className="ineerCard">
                <div className="innerIcon">
                  <img src={ic_category} alt="" />
                </div>
                <div className="innerText">
                  <div className="col headingText">CATEGORIES</div>
                  <div className="col count">{dashCount?.categoryCount}</div>
                </div>
              </div>
            </Link>
          </div>
          <div className="col-md-4">
            <Link className="mainCards" to="/Products">
              <div className="ineerCard">
                <div className="innerIcon">
                  <img src={ic_product} alt="" />
                </div>
                <div className="innerText">
                  <div className="col headingText">PRODUCTS</div>
                  <div className="col count">{dashCount?.productCount}</div>
                </div>
              </div>
            </Link>
          </div>
          <div className="col-md-4">
            <Link className="mainCards" to="/Orders">
              <div className="ineerCard">
                <div className="innerIcon">
                  <img src={ic_order} alt="" />
                </div>
                <div className="innerText">
                  <div className="col headingText">ORDERS</div>
                  <div className="col count">{dashCount?.orderCount}</div>
                </div>
              </div>
            </Link>
          </div>
        </div>
        {/* <div className="row ">
          <div className="col-md-4">
            <Link className="mainCards" to="/TransactionHistory">
              <div className="ineerCard">
                <div className="innerIcon">
                  <img src={ic_transaction} alt="" />
                </div>
                <div className="innerText">
                  <div className="col headingText">
                    TRANSACTION <br /> HISTORY
                  </div>
                  <div className="col count">{dashCount?.trasactionCount}</div>
                </div>
              </div>
            </Link>
          </div>
          <div className="col-md-4">
            <Link className="mainCards" to="/QRCodeManagement">
              <div className="ineerCard">
                <div className="innerIcon">
                  <img src={ic_qr} alt="" />
                </div>
                <div className="innerText">
                  <div className="col headingText">QR CODE MANAGMENT</div>
                  <div className="col count">{dashCount?.qrCodeCount}</div>
                </div>
              </div>
            </Link>
          </div>
          <div className="col-md-4">
            <Link className="mainCards" to="/QueryManagement">
              <div className="ineerCard">
                <div className="innerIcon">
                  <img src={ic_query} alt="" />
                </div>
                <div className="innerText">
                  <div className="col headingText">QUERY MANAGMENT</div>
                  <div className="col count">{dashCount?.queryManagmentCount}</div>
                </div>
              </div>
            </Link>
          </div>
        </div> */}
      </div>
    </main>
  );
};

export default Dashboard;
